import React from "react";

import * as S from "./styled";

const SocialLinks = () => (
  <S.SocialLinks>
    <S.SocialLink>
      <a
        href="https://twitter.com/streeteasy"
        rel="noreferrer noopener"
        target="_blank"
      >
        <S.TwitterIcon />
      </a>
    </S.SocialLink>
    <S.SocialLink>
      <a
        href="https://www.facebook.com/streeteasy/"
        rel="noreferrer noopener"
        target="_blank"
      >
        <S.FacebookIcon />
      </a>
    </S.SocialLink>
    <S.SocialLink>
      <a
        href="https://www.instagram.com/streeteasy/"
        rel="noreferrer noopener"
        target="_blank"
      >
        <S.InstagramIcon />
      </a>
    </S.SocialLink>
  </S.SocialLinks>
);

export default SocialLinks;
